// extracted by mini-css-extract-plugin
export default {"shadowElement":"2px 4px 4px 0px #000","tableShadow":"2px 2px 10px 0px rgba(28,38,61,.4)"};